import React, { useEffect } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getMe, selectMe } from "../redux/slices/generalSlice";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import LoadingButton from "../components/LoadingButton";
import { topupBalance } from "../redux/slices/publicSlice";
import { Helmet } from "react-helmet-async";

const Topup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const me = useSelector(selectMe);

  useEffect(() => {
    dispatch(getMe());
  }, []);

  const RegisterSchema = Yup.object().shape({
    balance: Yup.string().required("Topup Amount is required"),
  });

  const formik = useFormik({
    initialValues: {
      balance: "",
    },
    validationSchema: RegisterSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      console.log(values);

      setSubmitting(true);
      await dispatch(topupBalance({ ...values, navigate }));
      setSubmitting(false);
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, values, setValues } = formik;

  return (
    <>
      <Helmet>
        <title>Topup - LightningProxies</title>
      </Helmet>
      <div class="page-body-wrapper">
        <div class="row text-start">
          <div class="col-12 col-md-7 col-xl-6">
            <div class="header-title">
              <h1>Deposit Balance</h1>
              <p>Add balance to your account, using cryptocurrency</p>
            </div>
          </div>
          <div class="col-12 col-md-5 col-xl-6">
            <div class="header-bttn">
              <p>
                Need Support?{" "}
                <a href="https://t.me/lightningproxies">
                  Contact Us <i class="fa fa-angle-right"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="row text-start">
          <div class="col-lg-4 col-12">
            <div class="topup-form-wrap mt-15">
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit} className="text-start">
                  <div class="form-group m-0">
                    <label for="">Enter Topup Amount</label>
                    <input type="text" placeholder="$0.00" class="form-control" {...getFieldProps("balance")} />
                    {/* <span>$</span> */}
                  </div>
                  <span
                    className="invalid-feedback"
                    style={{
                      display: Boolean(touched.balance && errors.balance) ? "block" : "none",
                    }}
                  >
                    {errors.balance}
                  </span>

                  {/* Errors from server */}
                  {errors.afterSubmit && (
                    <div className="alert alert-danger" role="alert">
                      {errors.afterSubmit}
                    </div>
                  )}
                  <div class="form-bttn">
                    <LoadingButton loading={isSubmitting} type="submit" class="btn btn-submit">
                      Add Balance
                      <i className="fa fa-angle-right ms-1" />
                    </LoadingButton>
                  </div>
                </Form>
              </FormikProvider>
            </div>
            <div class="supported-curency mt-3 p-4">
              <h5>Supported Cryptocurrencies</h5>
              <div class="d-flex flex-wrap  justify-content-between">
                <ul>
                  <li>
                    <img src="./assets/images/icons/b.svg" alt="a" class="img-fluid" /> BTC = BTC Network
                  </li>
                  <li>
                    <img src="./assets/images/icons/e.svg" alt="a" class="img-fluid" /> ETH = ERC20 Network
                  </li>
                  <li>
                    <img src="./assets/images/icons/u.svg" alt="a" class="img-fluid" /> USDC = ERC20 Network
                  </li>
                  <li>
                    <img src="./assets/images/icons/d.svg" alt="a" class="img-fluid" /> Dogecoin = Dogecoin Network
                  </li>
                </ul>

                <ul>
                  <li>
                    <img src="./assets/images/icons/l.svg" alt="a" class="img-fluid" /> LTC = LTC Network
                  </li>
                  <li>
                    <img src="./assets/images/icons/da.svg" alt="a" class="img-fluid" /> DAI = ERC20 Network
                  </li>
                  <li>
                    <img src="./assets/images/icons/bc.svg" alt="a" class="img-fluid" /> BCH = Bitcoin Cash Network
                  </li>
                  <li>
                    <img src="./assets/images/icons/ut.svg" alt="a" class="img-fluid" /> USDT = ERC20 Network
                  </li>
                </ul>
              </div>
            </div>
            <div class="text-center mt-3">
              <a href="#">
                <img src="./assets/images/cryptoMus.svg" style={{ maxWidth: '50%' }} alt="Coinbase" class="img-fluid d-light" />
                <img src="./assets/images/cryptoMus-dark.svg" style={{ maxWidth: '50%' }} alt="Coinbase" class="img-fluid d-dark" />
              </a>
            </div>
          </div>
          <div class="col-lg-8 col-12">
            <div class="add-balance-benifit mt-15">
              <div class="media d-flex justify-content-center flex-wrap my-4 py-1 px-4 ">
                <div class="main-thumb d-lg-block d-none" style={{ minWidth: "26.625rem", minHeight: "17.75rem" }}>
                  <img src="./assets/images/vector.svg" alt="Vector" class="img-fluid d-light" />
                  <img src="./assets/images/vector-dark.svg" alt="Vector" class="img-fluid d-dark" />
                </div>
                <div class="main-thumb d-lg-none ">
                  <img src="./assets/images/vector.svg" alt="Vector" class="img-fluid d-light" />
                  <img src="./assets/images/vector-dark.svg" alt="Vector" class="img-fluid d-dark" />
                </div>
                <div class="media-body text-wrap">
                  <h5
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "500",
                      lineHeight: "24px",
                      letterSpacing: "-0.04em",
                    }}
                  >
                    Benefits to adding Account Balance
                  </h5>
                  <p id="referal-body">
                    Adding balance via top-up has several advantages for regular users. Hassle of going through wallets and network
                    confirmations is completely removed for future purchases.
                  </p>

                  <div class="d-flex justify-content-between justify-content-lg-start text-nowrap flex-wrap gap-2 topup-list">
                    <ul>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Extended Usage
                      </li>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Cost Savings
                      </li>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Convenience
                      </li>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Faster Transactions
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Budget Control
                      </li>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Continuous Access
                      </li>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Reduced Transaction Fees
                      </li>
                      <li>
                        <img src="./assets/images/icons/check.svg" alt="a" class="img-fluid" /> Time Savings
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Topup;
